<template>
  <div v-if="masterCampaign">
    <vx-card>
      <vs-row vs-justify="space-between">
        <vs-col vs-w="6">
          <h3 class="mr-4">Campaigns to be sent</h3>
          <p class="mt-5">By clicking the button above, the following approved campaigns will be sent</p>
        </vs-col>
      </vs-row>

      <div class="data-list-container data-list-list-view">
        <vs-table
          ref="table"
          class="mt-8"
          v-model="selected"
          pagination
          search
          :data="approvedCampaigns"
          @selected="onClicked(selected.id)"
        >
          <template slot="thead">
            <vs-th>Venue name</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>VM fill out by</vs-th>
            <vs-th>Send by</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.venueName }}
                  </p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="statusObject(tr.status).color" class="product-order-status">
                    {{ statusObject(tr.status).text }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.approvedByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.sendByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <preview-popup ref="previewPopup" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import PreviewPopup from "./PreviewCampaignPopup.vue";

export default {
  components: { PreviewPopup },
  mixins: [campaignMixin],
  props: ["masterCampaign"],
  data() {
    return {
      moment,
      selected: [],
      popupActive: false,
      popupCampaign: null,
    };
  },
  methods: {
    async onClicked(id) {
      await this.$store.dispatch("venueCampaigns/get", id);
      this.$refs.previewPopup.show(this.venueCampaign, this.masterCampaign);
    },
  },
  computed: {
    ...mapGetters({
      venueCampaigns: "venueCampaigns/masterVenueCampaigns",
      venueCampaign: "venueCampaigns/venueCampaign",
    }),
    approvedCampaigns() {
      return this.venueCampaigns.filter(
        e =>
          e.status == "Approved" || e.status == "Sent" || e.status == "NotSent" || e.status == "ErrorSending",
      );
    },
  },

  async created() {
    console.log("Getting for id", this.masterCampaign.id);
    await this.$store.dispatch("venueCampaigns/getForMasterCampaign", this.masterCampaign.id);
  },
};
</script>

<style lang="scss">
</style>
